// Quiz icons: history, explorers, inventions. Same rules as science.js.
export const HISTORY_ICONS = [
  { id: "pyramid", en: "Pyramid", da: "Pyramide", svg: `
<circle cx="92" cy="26" r="11" fill="#FFC857"/>
<path d="M8 100 h104" fill="none" stroke="#E9C46A"/>
<path d="M20 100 L60 30 L100 100Z" fill="#F4C976"/>
<path d="M60 30 L74 100 L100 100Z" fill="#E0A955" stroke="none"/>
<path d="M20 100 L60 30 L100 100Z" fill="none"/>
<path d="M38 70 h44 M30 84 h60 M47 54 h26" fill="none" stroke-width="3"/>
<path d="M54 100 v-10 a6 6 0 0 1 12 0 v10" fill="#3B3355"/>` },

  { id: "pharaoh", en: "Pharaoh", da: "Farao", svg: `
<path d="M24 104 C26 70 30 52 34 40 C38 18 82 18 86 40 C90 52 94 70 96 104Z" fill="#7FC8F8"/>
<path d="M30 60 h60 M28 74 h64 M26 88 h68" fill="none" stroke="#FFC857" stroke-width="6"/>
<path d="M40 44 C40 30 80 30 80 44 V74 C80 90 40 90 40 74Z" fill="#E0A955"/>
<path d="M34 40 C38 18 82 18 86 40 C70 34 50 34 34 40Z" fill="#FFC857"/>
<path d="M54 24 q6 -14 12 0 q-6 6 -12 0Z" fill="#7BD389" stroke-width="3"/>
<circle cx="52" cy="56" r="3.5" fill="#3B3355" stroke="none"/><circle cx="68" cy="56" r="3.5" fill="#3B3355" stroke="none"/>
<path d="M45 52 h12 M63 52 h12" fill="none" stroke-width="3"/>
<path d="M54 68 q6 4 12 0" fill="none" stroke-width="3"/>
<path d="M56 84 h8 v16 h-8Z" fill="#7FC8F8"/>` },

  { id: "hieroglyphs", en: "Hieroglyphs", da: "Hieroglyffer", svg: `
<rect x="22" y="10" width="76" height="100" rx="6" fill="#F4E1C1"/>
<path d="M22 36 h76 M22 62 h76 M22 86 h76" fill="none" stroke="#E0A955" stroke-width="3"/>
<circle cx="40" cy="23" r="6" fill="none" stroke-width="3.5"/><path d="M52 30 l6 -14 6 14Z" fill="none" stroke-width="3.5"/><path d="M72 18 q10 0 10 6 q0 6 -10 6" fill="none" stroke-width="3.5"/>
<path d="M34 54 q2 -10 10 -10 q4 2 2 6 l6 4 h-18Z" fill="#7FC8F8" stroke-width="3"/><path d="M62 42 v14 M58 46 q4 -6 8 0" fill="none" stroke-width="3.5"/><path d="M74 54 q6 -12 12 0" fill="none" stroke-width="3.5"/>
<path d="M36 74 h14 M43 68 v14" fill="none" stroke-width="3.5"/><circle cx="64" cy="74" r="4" fill="#E8556D" stroke-width="3"/><path d="M76 80 l6 -12 6 12" fill="none" stroke-width="3.5"/>
<path d="M38 98 q8 -8 16 0 M66 92 h16 v10 h-16Z" fill="none" stroke-width="3.5"/>` },

  { id: "vikingship", en: "Viking ship", da: "Vikingeskib", svg: `
<path d="M10 104 q15 -6 25 0 t25 0 t25 0 t25 0" fill="none" stroke="#7FC8F8"/>
<path d="M58 18 v62" fill="none"/>
<path d="M34 24 h48 q6 24 0 48 h-48 q-6 -24 0 -48Z" fill="#fff"/>
<path d="M40 24 v48 M58 24 v48 M76 24 v48" stroke="#E8556D" stroke-width="7"/>
<path d="M34 24 h48 q6 24 0 48 h-48 q-6 -24 0 -48Z" fill="none"/>
<path d="M14 78 h92 l-14 18 h-64Z" fill="#B07A57"/>
<path d="M14 78 q-6 -10 2 -16 q6 2 2 8" fill="#B07A57"/><path d="M106 78 q6 -10 -2 -16 q-6 2 -2 8" fill="#B07A57"/>
<circle cx="36" cy="86" r="4" fill="#FFC857" stroke-width="2.5"/><circle cx="52" cy="86" r="4" fill="#7FC8F8" stroke-width="2.5"/><circle cx="68" cy="86" r="4" fill="#FFC857" stroke-width="2.5"/><circle cx="84" cy="86" r="4" fill="#7FC8F8" stroke-width="2.5"/>` },

  { id: "vikinghelmet", en: "Vikings", da: "Vikinger", svg: `
<path d="M28 58 C12 50 8 34 14 18 C20 30 28 36 38 40Z" fill="#FFF3DC"/>
<path d="M92 58 C108 50 112 34 106 18 C100 30 92 36 82 40Z" fill="#FFF3DC"/>
<path d="M26 72 C26 38 94 38 94 72Z" fill="#B5B9D4"/>
<path d="M60 38 v34" fill="none" stroke-width="5"/>
<rect x="20" y="68" width="80" height="12" rx="4" fill="#E0A955"/>
<circle cx="34" cy="74" r="2.5" fill="#3B3355" stroke="none"/><circle cx="60" cy="74" r="2.5" fill="#3B3355" stroke="none"/><circle cx="86" cy="74" r="2.5" fill="#3B3355" stroke="none"/>
<path d="M52 80 h16 v24 l-8 6 -8 -6Z" fill="#B5B9D4"/>
<path d="M36 60 q2 -10 10 -14" fill="none" stroke="#fff" stroke-width="4"/>` },

  { id: "runestone", en: "Rune stone", da: "Runesten", svg: `
<path d="M8 106 h104" fill="none" stroke="#7BD389" stroke-width="6"/>
<path d="M34 106 C26 70 30 30 50 16 C66 8 86 20 88 44 C90 66 88 88 84 106Z" fill="#C9CCE0"/>
<path d="M42 100 C38 70 40 40 54 28 C66 20 78 30 80 46 C82 66 80 86 78 100" fill="none" stroke="#E8556D" stroke-width="4"/>
<path d="M54 44 v20 M54 50 l8 -6 M66 42 l6 10 -6 10 M58 74 v18 M58 82 l8 6 M70 72 v20 M70 72 l6 6" fill="none" stroke-width="4"/>` },

  { id: "hammer", en: "Norse gods", da: "Nordiske guder", svg: `
<path d="M100 14 l-6 6 M110 30 h-8 M88 8 v8" fill="none" stroke="#FFC857" stroke-width="5"/>
<path d="M54 56 h12 v44 a6 6 0 0 1 -12 0Z" fill="#B07A57"/>
<path d="M58 66 h4 M58 76 h4 M58 86 h4" fill="none" stroke-width="3"/>
<path d="M24 22 h72 v26 a8 8 0 0 1 -8 8 h-56 a8 8 0 0 1 -8 -8Z" fill="#B5B9D4"/>
<path d="M30 30 h60" fill="none" stroke="#fff" stroke-width="4" opacity=".8"/>
<path d="M40 40 q6 -6 12 0 t12 0 t12 0 t12 0" fill="none" stroke="#E0A955" stroke-width="4"/>
<circle cx="60" cy="110" r="5" fill="#FFC857" stroke-width="3"/>` },

  { id: "castle", en: "Castle", da: "Borg", svg: `
<rect x="22" y="44" width="76" height="58" fill="#C9CCE0"/>
<rect x="14" y="30" width="22" height="72" fill="#B5B9D4"/><rect x="84" y="30" width="22" height="72" fill="#B5B9D4"/>
<path d="M14 30 l11 -16 11 16Z M84 30 l11 -16 11 16Z" fill="#E8556D"/>
<path d="M50 102 v-20 a10 10 0 0 1 20 0 v20" fill="#8E5E40"/>
<path d="M36 44 v-8 h10 v8 h8 v-8 h12 v8 h8 v-8 h10 v8" fill="none"/>
<path d="M95 14 v-8 l10 3 -10 3" fill="#FFC857" stroke-width="3"/>
<rect x="21" y="50" width="8" height="12" rx="4" fill="#3B3355" stroke="none"/><rect x="91" y="50" width="8" height="12" rx="4" fill="#3B3355" stroke="none"/>` },

  { id: "crown", en: "Kings & queens", da: "Konger og dronninger", svg: `
<path d="M14 40 L34 64 L60 26 L86 64 L106 40 L98 92 H22Z" fill="#FFC857"/>
<rect x="20" y="88" width="80" height="14" rx="4" fill="#E0A955"/>
<circle cx="14" cy="38" r="6" fill="#FFE37A"/><circle cx="60" cy="22" r="7" fill="#FFE37A"/><circle cx="106" cy="38" r="6" fill="#FFE37A"/>
<circle cx="40" cy="95" r="4" fill="#E8556D" stroke-width="2.5"/><circle cx="60" cy="95" r="4" fill="#7FC8F8" stroke-width="2.5"/><circle cx="80" cy="95" r="4" fill="#7BD389" stroke-width="2.5"/>
<path d="M30 76 q4 -10 10 -12" fill="none" stroke="#fff" stroke-width="4"/>` },

  { id: "knight", en: "Knight", da: "Ridder", svg: `
<path d="M60 14 C86 14 94 34 94 58 V96 H26 V58 C26 34 34 14 60 14Z" fill="#C9CCE0"/>
<path d="M60 14 C62 6 72 2 80 4 C78 12 70 14 64 16" fill="#E8556D"/>
<path d="M34 52 h52 v8 h-52Z M34 66 h52" fill="#3B3355"/>
<path d="M60 70 v26 M46 76 h6 M68 76 h6 M46 86 h6 M68 86 h6" fill="none" stroke-width="3.5"/>
<path d="M36 40 q4 -16 18 -20" fill="none" stroke="#fff" stroke-width="5"/>
<path d="M20 96 h80 v10 h-80Z" fill="#B5B9D4"/>` },

  { id: "shield", en: "Middle Ages", da: "Middelalderen", svg: `
<path d="M60 10 L100 22 C100 64 88 94 60 110 C32 94 20 64 20 22Z" fill="#7FC8F8"/>
<path d="M60 10 V110 C88 94 100 64 100 22Z" fill="#4A90D9" stroke="none"/>
<path d="M60 10 L100 22 C100 64 88 94 60 110 C32 94 20 64 20 22Z M60 10 V110 M22 50 H98" fill="none"/>
<path d="M60 36 l4 8 9 1 -7 6 2 9 -8 -5 -8 5 2 -9 -7 -6 9 -1z" fill="#FFC857" stroke-width="3"/>
<path d="M30 30 q4 18 14 30" fill="none" stroke="#fff" stroke-width="4" opacity=".7"/>` },

  { id: "scroll", en: "Old document", da: "Gammelt dokument", svg: `
<path d="M30 20 h60 v76 a10 10 0 0 1 -10 10 h-60 a10 10 0 0 1 -10 -10 v-6 h20Z" fill="#FFF3DC"/>
<path d="M30 20 a10 10 0 0 0 -10 10 v4 h20 v-4 a10 10 0 0 0 -10 -10Z" fill="#F4C976"/>
<path d="M10 90 h60 v6 a10 10 0 0 0 10 10 h-60 a10 10 0 0 1 -10 -10Z" fill="#F4C976"/>
<path d="M48 38 h30 M48 50 h30 M48 62 h24 M48 74 h30" fill="none" stroke="#B07A57" stroke-width="3.5"/>
<circle cx="76" cy="88" r="8" fill="#E8556D"/><path d="M72 96 l-2 10 M80 96 l2 10" fill="none" stroke="#E8556D" stroke-width="4"/>` },

  { id: "quill", en: "Writing", da: "Skrift", svg: `
<path d="M30 92 C32 62 52 28 100 12 C98 50 76 80 40 92Z" fill="#fff"/>
<path d="M36 90 C52 70 70 44 94 18" fill="none" stroke-width="3"/>
<path d="M58 60 l-10 -4 M70 46 l-10 -4 M80 34 l-8 -4" fill="none" stroke-width="3"/>
<path d="M36 90 L22 108" fill="none" stroke-width="5"/>
<path d="M60 92 h40 l-6 18 h-28Z" fill="#3B3355"/><rect x="58" y="88" width="44" height="7" rx="3" fill="#7FC8F8"/>` },

  { id: "book", en: "Book", da: "Bog", svg: `
<path d="M60 26 C46 16 26 14 10 20 V96 C26 90 46 92 60 102Z" fill="#fff"/>
<path d="M60 26 C74 16 94 14 110 20 V96 C94 90 74 92 60 102Z" fill="#fff"/>
<path d="M10 96 v6 C26 96 46 98 60 108 C74 98 94 96 110 102 v-6" fill="#7FC8F8"/>
<path d="M20 34 q16 -4 30 2 M20 48 q16 -4 30 2 M20 62 q16 -4 30 2 M70 36 q14 -6 30 -2 M70 50 q14 -6 30 -2 M70 64 q14 -6 30 -2" fill="none" stroke="#C9CCE0" stroke-width="4"/>
<path d="M60 26 V102" fill="none"/>
<path d="M92 4 l3 6 6 1 -5 4 1 6 -5 -3 -5 3 1 -6 -5 -4 6 -1z" fill="#FFE37A" stroke-width="2.5"/>` },

  { id: "printingpress", en: "Printing", da: "Bogtryk", svg: `
<path d="M20 106 h80" fill="none" stroke-width="6"/>
<path d="M26 106 v-82 M94 106 v-82 M20 22 h80" fill="none" stroke="#B07A57" stroke-width="10"/>
<path d="M26 106 v-82 M94 106 v-82 M20 22 h80" fill="none" stroke-width="3"/>
<path d="M60 22 v28" fill="none" stroke-width="6"/><path d="M42 30 h36" fill="none" stroke-width="5"/>
<rect x="36" y="50" width="48" height="12" rx="2" fill="#B5B9D4"/>
<rect x="32" y="76" width="56" height="20" rx="2" fill="#fff"/>
<path d="M40 82 h14 M58 82 h22 M40 89 h24 M68 89 h12" fill="none" stroke-width="3"/>` },

  { id: "caravel", en: "Explorers", da: "Opdagelsesrejsende", svg: `
<path d="M8 104 q14 -6 26 0 t26 0 t26 0 t26 0" fill="none" stroke="#7FC8F8"/>
<path d="M50 12 v74 M82 26 v60" fill="none"/>
<path d="M30 22 h40 q6 16 0 30 h-40 q-6 -14 0 -30Z" fill="#fff"/>
<path d="M32 58 h36 q6 10 0 20 h-36 q-6 -10 0 -20Z" fill="#fff"/>
<path d="M68 34 h28 q4 12 0 24 h-28 q-4 -12 0 -24Z" fill="#fff"/>
<path d="M42 30 l8 6 8 -6 M42 64 l8 6 8 -6" fill="none" stroke="#E8556D" stroke-width="4"/>
<path d="M12 84 h96 l-14 18 h-68Z" fill="#B07A57"/>
<path d="M50 12 l14 4 -14 4" fill="#E8556D" stroke-width="3"/>
<path d="M24 92 h72" fill="none" stroke="#8E5E40" stroke-width="3"/>` },

  { id: "compass", en: "Compass", da: "Kompas", svg: `
<circle cx="60" cy="60" r="46" fill="#E0A955"/><circle cx="60" cy="60" r="36" fill="#FFF3DC"/>
<path d="M60 26 l9 34 -9 34 -9 -34Z" fill="#fff"/><path d="M60 26 l9 34 h-18Z" fill="#E8556D"/>
<path d="M60 26 l9 34 -9 34 -9 -34Z" fill="none"/>
<circle cx="60" cy="60" r="5" fill="#3B3355"/>
<path d="M60 14 v-6 M60 106 v6 M14 60 h-6 M106 60 h6" fill="none"/>
<path d="M92 28 l-4 4 M28 92 l4 -4 M92 92 l-4 -4 M28 28 l4 4" fill="none" stroke-width="3"/>` },

  { id: "treasuremap", en: "Map", da: "Kort", svg: `
<path d="M12 26 l30 -10 36 10 30 -10 v78 l-30 10 -36 -10 -30 10Z" fill="#FFF3DC"/>
<path d="M42 16 v78 M78 26 v78" fill="none" stroke="#E0A955" stroke-width="3"/>
<path d="M22 84 q14 -2 18 -14 q6 -16 22 -12 q16 4 18 -10 q2 -12 14 -14" fill="none" stroke="#E8556D" stroke-width="4" stroke-dasharray="6 7"/>
<path d="M88 30 l10 10 M98 30 l-10 10" fill="none" stroke="#E8556D" stroke-width="5"/>
<path d="M18 40 q8 -6 14 2 q-2 10 -12 6Z" fill="#7BD389" stroke-width="3"/>` },

  { id: "globe", en: "Globe", da: "Globus", svg: `
<path d="M60 92 v10 M40 108 h40 l-6 -8 h-28Z" fill="#B07A57"/>
<path d="M30 20 a44 44 0 0 0 30 80" fill="none" stroke="#E0A955" stroke-width="7"/>
<circle cx="62" cy="54" r="36" fill="#7FC8F8"/>
<path d="M40 40 q10 -12 22 -8 q4 8 -4 12 q-2 10 -12 8 q-8 -4 -6 -12Z M70 56 q12 -6 20 4 q0 14 -12 16 q-8 -2 -6 -10 q-6 -4 -2 -10Z" fill="#7BD389"/>
<path d="M40 68 q6 10 16 14" fill="none" stroke="#fff" stroke-width="4" opacity=".7"/>` },

  { id: "greatwall", en: "Great Wall", da: "Den Kinesiske Mur", svg: `
<path d="M4 76 q20 -30 40 -26 q20 4 32 -14 q12 -14 40 -10 v18 q-24 -2 -34 12 q-14 20 -38 16 q-20 -4 -40 24Z" fill="#7BD389" stroke="none"/>
<path d="M2 92 C20 64 38 58 54 62 C70 66 80 46 92 38 C100 32 108 32 116 34 V50 C106 48 100 50 94 56 C84 66 74 84 54 80 C38 76 24 84 14 104Z" fill="#E0A955"/>
<path d="M2 92 l4 -6 4 4 4 -8 4 3 4 -7 4 2 4 -6 4 1 4 -4 4 1 4 -2 4 2 4 -2 4 1 4 -4 4 0 4 -6 4 -2 4 -6 4 -2 4 -4 4 0 4 -2" fill="none" stroke-width="3.5"/>
<rect x="44" y="44" width="18" height="26" fill="#F4C976"/><path d="M44 44 l3 -6 h12 l3 6Z" fill="#E8556D" stroke-width="3"/>
<rect x="88" y="22" width="14" height="22" fill="#F4C976"/><path d="M88 22 l2 -5 h10 l2 5Z" fill="#E8556D" stroke-width="3"/>
<path d="M20 86 l10 -4 M66 72 l12 -8" fill="none" stroke-width="3"/>` },

  { id: "greektemple", en: "Ancient Greece", da: "Oldtidens Grækenland", svg: `
<path d="M12 40 L60 12 L108 40Z" fill="#F4E1C1"/>
<rect x="14" y="40" width="92" height="10" fill="#fff"/>
<rect x="20" y="50" width="12" height="44" fill="#fff"/><rect x="42" y="50" width="12" height="44" fill="#fff"/><rect x="66" y="50" width="12" height="44" fill="#fff"/><rect x="88" y="50" width="12" height="44" fill="#fff"/>
<path d="M26 54 v36 M48 54 v36 M72 54 v36 M94 54 v36" fill="none" stroke="#C9CCE0" stroke-width="3"/>
<rect x="12" y="94" width="96" height="8" fill="#F4E1C1"/><rect x="6" y="102" width="108" height="8" fill="#fff"/>
<circle cx="60" cy="30" r="5" fill="#7FC8F8" stroke-width="3"/>` },

  { id: "colosseum", en: "Ancient Rome", da: "Romerriget", svg: `
<path d="M10 40 C10 26 110 26 110 40 V100 C110 108 10 108 10 100Z" fill="#F4C976"/>
<path d="M10 40 C10 50 110 50 110 40" fill="none"/>
<path d="M10 66 C30 72 90 72 110 66" fill="none"/>
<g fill="#B07A57" stroke-width="3"><path d="M20 62 v-8 a5 5 0 0 1 10 0 v8Z M40 66 v-9 a5 5 0 0 1 10 0 v9Z M60 67 v-9 a5 5 0 0 1 10 0 v9Z M80 66 v-9 a5 5 0 0 1 10 0 v9Z M98 62 v-8 a4 4 0 0 1 8 0 v8Z"/>
<path d="M20 94 v-12 a5 5 0 0 1 10 0 v14Z M40 98 v-12 a5 5 0 0 1 10 0 v13Z M60 99 v-12 a5 5 0 0 1 10 0 v12Z M80 98 v-12 a5 5 0 0 1 10 0 v12Z M98 95 v-12 a4 4 0 0 1 8 0 v10Z"/></g>
<path d="M90 30 L110 40 V60 L96 54Z" fill="#E0A955" stroke="none"/>` },

  { id: "romanhelmet", en: "Romans", da: "Romerne", svg: `
<path d="M30 42 C30 6 90 6 90 42 C80 52 40 52 30 42Z" fill="#E8556D"/>
<path d="M42 26 v8 M52 20 v10 M60 18 v12 M68 20 v10 M78 26 v8" fill="none" stroke="#C8404F" stroke-width="3"/>
<path d="M26 72 C26 30 94 30 94 72Z" fill="#FFC857"/>
<path d="M26 70 h18 v24 a9 9 0 0 1 -18 0Z M76 70 h18 v24 a9 9 0 0 1 -18 0Z" fill="#FFC857"/>
<path d="M20 72 h80" fill="none" stroke-width="7"/><path d="M20 72 h80" fill="none" stroke="#E0A955" stroke-width="2.5"/>
<circle cx="35" cy="84" r="3" fill="#E0A955" stroke-width="2.5"/><circle cx="85" cy="84" r="3" fill="#E0A955" stroke-width="2.5"/>
<path d="M38 56 q4 -12 14 -16" fill="none" stroke="#fff" stroke-width="4"/>` },

  { id: "amphora", en: "Archaeology", da: "Arkæologi", svg: `
<path d="M48 12 h24 v10 c0 6 18 12 18 34 c0 26 -14 40 -20 48 h-20 c-6 -8 -20 -22 -20 -48 c0 -22 18 -28 18 -34Z" fill="#E07A5F"/>
<path d="M48 26 c-14 0 -18 14 -10 24 M72 26 c14 0 18 14 10 24" fill="none" stroke-width="5"/>
<path d="M34 60 h52 M38 76 h44" fill="none" stroke="#3B3355" stroke-width="3"/>
<path d="M42 66 l6 -4 6 4 6 -4 6 4 6 -4 6 4" fill="none" stroke="#FFF3DC" stroke-width="3"/>
<path d="M50 104 h20" fill="none" stroke-width="5"/>
<path d="M10 100 l14 -14 M18 110 l4 -12" fill="none" stroke="#B07A57" stroke-width="5"/>
<path d="M98 88 l10 -4 2 10 -10 2Z" fill="#E07A5F" stroke-width="3"/>` },

  { id: "hourglass", en: "Time", da: "Tid", svg: `
<rect x="24" y="8" width="72" height="12" rx="4" fill="#B07A57"/><rect x="24" y="100" width="72" height="12" rx="4" fill="#B07A57"/>
<path d="M34 20 h52 c0 24 -20 30 -20 40 c0 10 20 16 20 40 h-52 c0 -24 20 -30 20 -40 c0 -10 -20 -16 -20 -40Z" fill="#DDF1FF"/>
<path d="M40 30 h40 c-4 12 -16 18 -20 24 c-4 -6 -16 -12 -20 -24Z" fill="#F4C976" stroke="none"/>
<path d="M60 58 v34 M38 100 c4 -14 14 -16 22 -16 c8 0 18 2 22 16Z" fill="#F4C976" stroke="#F4C976" stroke-width="3"/>
<path d="M34 20 h52 c0 24 -20 30 -20 40 c0 10 20 16 20 40 h-52 c0 -24 20 -30 20 -40 c0 -10 -20 -16 -20 -40Z" fill="none"/>
<path d="M42 28 q2 12 10 18" fill="none" stroke="#fff" stroke-width="4"/>` },

  { id: "clock", en: "Clock", da: "Ur", svg: `
<circle cx="30" cy="24" r="12" fill="#FFC857"/><circle cx="90" cy="24" r="12" fill="#FFC857"/>
<path d="M38 104 l-8 8 M82 104 l8 8" fill="none" stroke-width="6"/>
<circle cx="60" cy="64" r="42" fill="#E8556D"/><circle cx="60" cy="64" r="32" fill="#fff"/>
<path d="M60 40 v4 M84 64 h-4 M60 88 v-4 M36 64 h4" fill="none" stroke-width="4"/>
<path d="M60 64 V46 M60 64 l12 8" fill="none" stroke-width="5"/>
<circle cx="60" cy="64" r="4" fill="#3B3355"/>` },

  { id: "calendar", en: "Calendar", da: "Kalender", svg: `
<rect x="14" y="20" width="92" height="88" rx="10" fill="#fff"/>
<path d="M14 30 a10 10 0 0 1 10 -10 h72 a10 10 0 0 1 10 10 v16 h-92Z" fill="#E8556D"/>
<path d="M36 12 v16 M84 12 v16" fill="none" stroke-width="6"/>
<g fill="#C9CCE0" stroke="none"><rect x="26" y="56" width="12" height="10" rx="2"/><rect x="46" y="56" width="12" height="10" rx="2"/><rect x="66" y="56" width="12" height="10" rx="2"/><rect x="26" y="74" width="12" height="10" rx="2"/><rect x="66" y="74" width="12" height="10" rx="2"/><rect x="86" y="74" width="12" height="10" rx="2"/><rect x="26" y="92" width="12" height="8" rx="2"/><rect x="46" y="92" width="12" height="8" rx="2"/></g>
<rect x="44" y="72" width="16" height="14" rx="3" fill="#FFC857"/>
<rect x="86" y="56" width="12" height="10" rx="2" fill="#7FC8F8" stroke-width="2.5"/>` },

  { id: "sundial", en: "Long ago", da: "For længe siden", svg: `
<path d="M14 100 h92 l-6 10 h-80Z" fill="#B5B9D4"/>
<ellipse cx="60" cy="80" rx="48" ry="20" fill="#F4E1C1"/>
<path d="M60 80 l-34 -6 M60 80 l-20 -16 M60 80 v-20 M60 80 l22 -14 M60 80 l36 -4" fill="none" stroke="#E0A955" stroke-width="3"/>
<path d="M60 80 L60 30 L90 80Z" fill="#B5B9D4"/>
<path d="M60 80 l-38 10" fill="none" stroke="#9AA0C2" stroke-width="6"/>
<circle cx="24" cy="24" r="12" fill="#FFC857"/>` },

  { id: "steamtrain", en: "Steam train", da: "Damptog", svg: `
<path d="M30 30 q-6 -8 2 -14 q4 -10 16 -6 q10 -6 18 4 q10 0 8 10" fill="#E5E1EE"/>
<rect x="24" y="38" width="16" height="20" fill="#3B3355"/>
<rect x="18" y="56" width="56" height="30" rx="6" fill="#E8556D"/>
<rect x="70" y="34" width="34" height="52" rx="4" fill="#4A90D9"/>
<rect x="78" y="42" width="18" height="16" rx="3" fill="#B7E0FB"/>
<path d="M66 30 h44" fill="none" stroke-width="6"/>
<path d="M8 86 l10 -10" fill="none" stroke-width="5"/>
<circle cx="34" cy="94" r="10" fill="#B5B9D4"/><circle cx="60" cy="94" r="10" fill="#B5B9D4"/><circle cx="88" cy="94" r="12" fill="#B5B9D4"/>
<circle cx="34" cy="94" r="3" fill="#3B3355" stroke="none"/><circle cx="60" cy="94" r="3" fill="#3B3355" stroke="none"/><circle cx="88" cy="94" r="3" fill="#3B3355" stroke="none"/>
<path d="M2 108 h116" fill="none" stroke="#B07A57" stroke-width="5"/>` },

  { id: "oldcar", en: "First cars", da: "De første biler", svg: `
<path d="M14 80 V66 q0 -8 10 -10 l14 -2 l10 -22 h34 l6 22 h12 q14 2 14 14 v12Z" fill="#7BD389"/>
<path d="M52 36 h26 l4 18 h-34Z" fill="#B7E0FB"/>
<path d="M64 36 v18" fill="none" stroke-width="3"/>
<circle cx="32" cy="84" r="14" fill="#fff"/><circle cx="88" cy="84" r="14" fill="#fff"/>
<path d="M32 72 v24 M20 84 h24 M88 72 v24 M76 84 h24" fill="none" stroke-width="3"/>
<circle cx="104" cy="66" r="5" fill="#FFE37A" stroke-width="3"/>
<path d="M60 62 h10" fill="none" stroke-width="4"/>` },

  { id: "biplane", en: "First flight", da: "Den første flyvning", svg: `
<path d="M22 22 q4 -8 12 -6 q6 -6 12 0 q8 0 6 8Z M80 96 q4 -8 12 -6 q6 -6 12 0 q8 0 6 8Z" fill="#fff" stroke-width="3"/>
<rect x="12" y="40" width="96" height="10" rx="5" fill="#E8556D"/>
<rect x="12" y="72" width="96" height="10" rx="5" fill="#E8556D"/>
<path d="M30 50 v22 M90 50 v22 M30 50 l60 22" fill="none" stroke-width="3"/>
<path d="M44 52 h44 q16 0 18 8 q-2 8 -18 8 h-44Z" fill="#FFC857"/>
<path d="M30 56 l10 -12 6 12Z" fill="#FFC857" stroke-width="3"/>
<path d="M106 48 v24" fill="none" stroke-width="5"/>
<circle cx="70" cy="56" r="5" fill="#8E5E40" stroke-width="3"/>` },

  { id: "telephone", en: "Telephone", da: "Telefon", svg: `
<path d="M26 34 C24 20 96 20 94 34 l-4 10 h-14 l-2 -8 h-28 l-2 8 h-14Z" fill="#3B3355"/>
<path d="M36 52 h48 l14 50 h-76Z" fill="#E8556D"/>
<circle cx="60" cy="76" r="16" fill="#fff"/>
<circle cx="60" cy="66" r="3" fill="#C9CCE0" stroke-width="2"/><circle cx="70" cy="72" r="3" fill="#C9CCE0" stroke-width="2"/><circle cx="68" cy="83" r="3" fill="#C9CCE0" stroke-width="2"/><circle cx="52" cy="83" r="3" fill="#C9CCE0" stroke-width="2"/><circle cx="50" cy="72" r="3" fill="#C9CCE0" stroke-width="2"/>
<path d="M54 44 v8 M66 44 v8" fill="none" stroke-width="4"/>` },

  { id: "hotairballoon", en: "Hot-air balloon", da: "Luftballon", svg: `
<path d="M60 8 C88 8 104 28 100 50 C96 68 74 78 70 90 H50 C46 78 24 68 20 50 C16 28 32 8 60 8Z" fill="#FF7A45"/>
<path d="M60 8 C48 20 44 60 52 90 M60 8 C72 20 76 60 68 90" fill="#FFC857"/>
<path d="M60 8 C48 20 44 60 52 90 M60 8 C72 20 76 60 68 90 M60 8 V90" fill="none"/>
<path d="M50 90 l-2 10 M70 90 l2 10" fill="none" stroke-width="3"/>
<path d="M46 100 h28 v12 h-28Z" fill="#B07A57"/>
<path d="M30 40 q2 -14 12 -22" fill="none" stroke="#fff" stroke-width="4"/>` },

  { id: "moonlanding", en: "Moon landing", da: "Månelandingen", svg: `
<circle cx="24" cy="22" r="3" fill="#FFE37A" stroke-width="2"/><circle cx="98" cy="16" r="2.5" fill="#FFE37A" stroke-width="2"/><circle cx="84" cy="40" r="2" fill="#FFE37A" stroke-width="2"/>
<path d="M2 96 q30 -24 58 -20 q32 4 58 20 v20 h-116Z" fill="#E5E1EE"/>
<ellipse cx="34" cy="96" rx="9" ry="4" fill="#C9CCE0"/><ellipse cx="86" cy="100" rx="7" ry="3" fill="#C9CCE0"/>
<path d="M56 80 V20" fill="none" stroke-width="5"/>
<rect x="56" y="20" width="40" height="26" fill="#fff"/>
<rect x="56" y="20" width="40" height="26" fill="#FFC857"/>
<path d="M76 25 l2.5 5 5.5 1 -4 4 1 5.5 -5 -2.5 -5 2.5 1 -5.5 -4 -4 5.5 -1z" fill="#fff" stroke-width="2.5"/>
<path d="M66 92 l6 -6 M74 96 l6 -6" fill="none" stroke="#9AA0C2" stroke-width="4"/>` },

  { id: "lighthouse", en: "Lighthouse", da: "Fyrtårn", svg: `
<path d="M66 28 l46 -14 v26Z M54 28 l-46 -14 v26Z" fill="#FFE37A" stroke="none" opacity=".8"/>
<path d="M44 108 L50 40 h20 l6 68Z" fill="#fff"/>
<path d="M48 64 h24 l2 16 h-28Z M46 92 h28 l2 16 h-32Z" fill="#E8556D"/>
<rect x="46" y="22" width="28" height="18" rx="3" fill="#FFC857"/>
<path d="M42 22 l18 -14 18 14Z" fill="#E8556D"/>
<path d="M40 40 h40" fill="none" stroke-width="5"/>
<path d="M2 110 q14 -8 28 0 M90 110 q14 -8 28 0" fill="none" stroke="#7FC8F8" stroke-width="5"/>` },

  { id: "windmill", en: "Windmill", da: "Vindmølle", svg: `
<path d="M42 108 L48 50 h24 l6 58Z" fill="#E0A955"/>
<path d="M44 50 L60 34 L76 50Z" fill="#E8556D"/>
<path d="M54 108 v-16 a6 6 0 0 1 12 0 v16" fill="#8E5E40"/>
<g transform="rotate(20 60 46)"><rect x="56" y="4" width="8" height="84" rx="2" fill="#fff"/><rect x="18" y="42" width="84" height="8" rx="2" fill="#fff"/>
<path d="M64 8 h12 v34 h-12 M56 84 h-12 v-34 h12 M22 42 v-12 h34 v12 M98 50 v12 h-34 v-12" fill="#F4E1C1" stroke-width="3"/></g>
<circle cx="60" cy="46" r="6" fill="#B07A57"/>` },

  { id: "camel", en: "Silk Road", da: "Silkevejen", svg: `
<path d="M4 108 q30 -10 56 -2 q30 -10 56 2" fill="#F4C976"/>
<path d="M30 74 v32 M42 76 v30 M76 76 v30 M88 72 v34" fill="none" stroke-width="7"/><path d="M30 74 v32 M42 76 v30 M76 76 v30 M88 72 v34" fill="none" stroke="#E0A955" stroke-width="2"/>
<path d="M24 76 C20 60 30 54 38 54 C42 36 54 36 58 50 C62 34 76 34 80 52 C88 54 92 46 94 36 L92 24 C96 18 106 20 106 26 L104 30 L100 34 C100 50 96 66 90 76 Z" fill="#E0A955"/>
<path d="M46 52 q12 -6 22 2 v14 h-22Z" fill="#E8556D" stroke-width="3"/>
<circle cx="100" cy="25" r="2.5" fill="#3B3355" stroke="none"/>
<path d="M48 56 h20 M48 62 h20" fill="none" stroke="#FFC857" stroke-width="3"/>` },

  { id: "coin", en: "Money & trade", da: "Penge og handel", svg: `
<ellipse cx="64" cy="88" rx="40" ry="14" fill="#E0A955"/>
<path d="M24 76 v12 M104 76 v12" fill="none"/>
<ellipse cx="64" cy="76" rx="40" ry="14" fill="#FFC857"/>
<circle cx="50" cy="44" r="30" fill="#FFC857"/><circle cx="50" cy="44" r="22" fill="none" stroke="#E0A955" stroke-width="3"/>
<path d="M50 30 l4.5 9 10 1.5 -7 7 1.5 10 -9 -4.5 -9 4.5 1.5 -10 -7 -7 10 -1.5z" fill="#FFE37A" stroke-width="3"/>
<path d="M98 20 l2 5 5 1 -4 3 1 5 -4 -3 -4 3 1 -5 -4 -3 5 -1z" fill="#FFE37A" stroke-width="2"/>` },

  { id: "treasure", en: "Treasure", da: "Skat", svg: `
<path d="M18 56 C18 34 102 34 102 56Z" fill="#B07A57"/>
<path d="M28 50 q8 -18 20 -20 l6 -6 6 8 8 -10 6 10 10 -4 4 10 q8 4 10 12" fill="#FFC857"/>
<rect x="18" y="56" width="84" height="48" rx="4" fill="#B07A57"/>
<path d="M18 70 h84 M38 56 v48 M82 56 v48" fill="none" stroke="#8E5E40" stroke-width="5"/>
<rect x="52" y="60" width="16" height="18" rx="3" fill="#FFC857"/><circle cx="60" cy="68" r="3" fill="#3B3355" stroke="none"/>
<path d="M18 56 C18 34 102 34 102 56Z" fill="none"/>
<path d="M100 14 l2 5 5 1 -4 3 1 5 -4 -3 -4 3 1 -5 -4 -3 5 -1z M16 18 l2 4 4 1 -3 3 1 4 -4 -2 -4 2 1 -4 -3 -3 4 -1z" fill="#FFE37A" stroke-width="2"/>` },

  { id: "dove", en: "Peace", da: "Fred", svg: `
<path d="M60 58 C54 36 64 18 86 10 C86 28 80 44 66 56Z" fill="#E5E1EE"/>
<path d="M14 62 C30 50 50 52 62 58 C70 50 82 46 94 52 L108 50 L100 60 C98 78 78 90 54 86 L36 100 L38 86 C26 82 18 74 14 62Z" fill="#fff"/>
<path d="M30 70 q16 -4 28 6" fill="none" stroke="#C9CCE0" stroke-width="4"/>
<circle cx="92" cy="56" r="3" fill="#3B3355" stroke="none"/>
<path d="M108 50 q8 6 2 14" fill="none" stroke="#5BB46C" stroke-width="4"/>
<path d="M110 60 q-10 -2 -10 6 q8 2 10 -6Z M112 54 q8 -4 6 4" fill="#7BD389" stroke-width="2.5"/>` },

  { id: "wall", en: "Walls & borders", da: "Mure og grænser", svg: `
<path d="M8 40 h104 v64 h-104Z" fill="#C9CCE0"/>
<path d="M8 56 h104 M8 72 h104 M8 88 h104 M30 40 v16 M64 40 v16 M98 40 v16 M46 56 v16 M82 56 v16 M22 72 v16 M58 72 v16 M94 72 v16 M38 88 v16 M74 88 v16" fill="none" stroke-width="3"/>
<path d="M60 40 l-6 14 10 4 -8 16 12 4 -6 26" fill="none" stroke="#3B3355" stroke-width="5"/>
<path d="M60 40 l-6 14 10 4 -8 16 12 4 -6 26" fill="none" stroke="#FFF8EC" stroke-width="2"/>
<path d="M86 40 v-16" fill="none" stroke="#5BB46C" stroke-width="4"/>
<circle cx="86" cy="18" r="5" fill="#FFC857" stroke-width="3"/><circle cx="80" cy="12" r="5" fill="#FF6B81" stroke-width="3"/><circle cx="92" cy="12" r="5" fill="#FF6B81" stroke-width="3"/><circle cx="80" cy="24" r="5" fill="#FF6B81" stroke-width="3"/><circle cx="92" cy="24" r="5" fill="#FF6B81" stroke-width="3"/><circle cx="86" cy="18" r="4" fill="#FFC857" stroke-width="2.5"/>` },

  { id: "torch", en: "Olympics", da: "OL", svg: `
<path d="M60 6 C64 20 80 24 78 42 C76 56 66 60 60 60 C52 60 42 54 42 42 C42 32 50 28 52 20 C56 28 58 30 60 30 C62 22 58 14 60 6Z" fill="#FF7A45"/>
<path d="M60 30 C62 38 70 42 68 50 C66 56 62 56 60 56 C56 56 52 52 52 48 C52 42 58 40 58 34Z" fill="#FFC857" stroke-width="3"/>
<path d="M38 60 h44 l-14 50 h-16Z" fill="#E0A955"/>
<rect x="34" y="56" width="52" height="10" rx="3" fill="#FFC857"/>
<path d="M46 76 h28 M50 90 h20" fill="none" stroke="#fff" stroke-width="4"/>` },

  { id: "trophy", en: "Winner", da: "Vinder", svg: `
<path d="M34 24 h-16 v10 c0 16 12 22 20 22 M86 24 h16 v10 c0 16 -12 22 -20 22" fill="none" stroke-width="6"/>
<path d="M30 14 h60 v22 c0 22 -14 34 -30 34 c-16 0 -30 -12 -30 -34Z" fill="#FFC857"/>
<path d="M52 70 h16 v14 h-16Z" fill="#E0A955"/>
<rect x="36" y="84" width="48" height="22" rx="4" fill="#B07A57"/><rect x="46" y="90" width="28" height="10" rx="2" fill="#FFC857" stroke-width="3"/>
<path d="M60 26 l4 8 9 1 -7 6 2 9 -8 -5 -8 5 2 -9 -7 -6 9 -1z" fill="#FFE37A" stroke-width="3"/>
<path d="M40 22 v14" fill="none" stroke="#fff" stroke-width="5"/>` },

  { id: "factory", en: "Industry", da: "Industri", svg: `
<path d="M30 22 q-4 -10 6 -14 q8 -6 14 2 q10 -2 10 8" fill="#E5E1EE"/>
<rect x="28" y="28" width="14" height="40" fill="#B07A57"/>
<path d="M10 108 V58 l26 -10 v10 l26 -10 v10 l26 -10 v10 l22 -8 v58Z" fill="#E8556D"/>
<rect x="20" y="74" width="14" height="12" rx="2" fill="#FFE37A"/><rect x="46" y="74" width="14" height="12" rx="2" fill="#FFE37A"/><rect x="72" y="74" width="14" height="12" rx="2" fill="#FFE37A"/>
<path d="M92 108 v-20 h12 v20" fill="#8E5E40"/>
<path d="M4 108 h112" fill="none"/>` },
];
